import * as Library from '../../../core/library/index';
import { Error } from './error';

/**
 * Response<T>
 */
export class Response<T> {
  public data: any;
  public total: number;
  public errors: Error[];

  hasErrors() {
    return Library.isArrayWithLength(this.errors);
  }

  hasData() {
    return Library.isArrayWithLength(this.data) ||
      (!Library.isArray(this.data) && Library.isObject(this.data));
  }

  /**
   * constructor()
   */
  constructor();
  constructor(options: any);
  constructor(options: any, map: any);

  // tslint:disable-next-line
  constructor(options?: any, map: any = undefined) {
    if (Library.isObject(options)) {
      this.data = [];

      if (Library.isArrayWithLength(options)) {
        //
        // if no map defined then...
        //
        if (Library.isUndefined(map)) {
          this.data = [...options];
        } else {
          this.data = options.map(o => map(o));
        }
      } else if (!Library.isArray(options)) {
        //
        // if no map defined then...
        //
        if (Library.isUndefined(map)) {
          this.data.push(options);
        } else {
          const obj = map(options);
          this.data.push(obj);
        }
      }

      this.errors = [];

      if (Library.hasOwnProperty(options, 'errors')) {
        this.errors = options.errors.map(e => {
          return new Error(e);
        });
      }

      this.total = Library.init(options, 'total', 0);
    }
  }
}
